/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Filter for downloadable content state. Accepts ALL, ALLOW, or BLOCK
 * @export
 * @enum {string}
 */

export enum DownloadableFilter {
    ALL = 'ALL',
    ALLOW = 'ALLOW',
    BLOCK = 'BLOCK'
}



